<template>
  <ExActionsPopUp
    :value="show"
    headline="Archive Checkpoints in Bulk"
    icon="checkpoint_pass"
    :htmlInfo="info"
    actionLabel="Archive in Bulk"
    :centerHeadline="true"
    :applyBorderClass="true"
    :width="500"
    :primary="true"
    :backgroundPatternBottomRight="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onArchive')"
    @input="$emit('onClose')"
    data-testid="checkpoints-bulk-archive-popup"
  >
  </ExActionsPopUp>
</template>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["onArchive", "onClose"]);

const info = computed(() => {
  return `<div class="bulk-archive-message">You are about to archive the selected Checkpoints.<br>Only checkpoints in status Retired will be archived.<br>The rest will be ignored.</div>`;
});
</script>

<style scoped>
:deep(.bulk-archive-message) {
  max-width: 454px;
  margin: 0 auto;
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px !important;
  color: #475467;
  white-space: normal !important;
}

:deep(.action_popup_title) {
  margin-top: 12px !important; /* Matches desired design compactness */
  margin-bottom: 8px !important;
}

:deep(.action_popup_message) {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

:deep(.ex_action_popup) {
  background-position: right -30px bottom -30px !important; /* Moves circles back to bottom right */
}
</style>
